<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface LockedProps {
  title?: string
  message?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { LockClosedIcon } from '@heroicons/vue/24/outline'
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '#ui-kit/ui/empty'

const props = withDefaults(defineProps<LockedProps>(), {
  title: 'Nothing to see here yet',
})

const slots = defineSlots<{
  default?: () => void
}>()
</script>

<template>
  <Empty :class="props.class">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <LockClosedIcon aria-hidden="true" />
      </EmptyMedia>

      <EmptyTitle>{{ title }}</EmptyTitle>

      <EmptyDescription v-if="message">{{ message }}</EmptyDescription>
    </EmptyHeader>

    <EmptyContent v-if="slots.default" class="max-w-none">
      <slot />
    </EmptyContent>
  </Empty>
</template>
